import React from 'react';

const withEcomAwareIframe = BaseComponent =>
  class WithEcomAwareIframe extends React.Component {
    constructor(props) {
      super(props);
      this.setRef = this.setRef.bind(this);
    }

    componentDidMount() {
      this.iframeEl = this.el.getElementsByTagName('iframe')[0];
      this.iframeEl.addEventListener('load', this.setEcomIntegration);
    }

    componentWillUnmount() {
      this.iframeEl = this.el.getElementsByTagName('iframe')[0];
      this.iframeEl.removeEventListener('load', this.setEcomIntegration);
    }

    setRef(el) {
      this.el = el;
    }

    setEcomIntegration = async () => {
      const integration = await window.merchantos.session.getEcomIntegration();

      const message = {
        type: 'setEcomIntegration',
        payload: { integration },
      };

      this.iframeEl.contentWindow.postMessage(message, '*');
    };

    render() {
      return (
        <div ref={this.setRef} style={{ width: '100%', height: '100%' }}>
          <BaseComponent {...this.props} />
        </div>
      );
    }
  };

export default withEcomAwareIframe;
